module.exports = __webpack_public_path__ + "static/media/admin.24b65457.svg";